import * as yup from 'yup';

export const UsuarioColumnList = (isAdmin) => {
   return [
      {
         id: 'usuario_id',
         dbname: 'id',
         label: 'id',
         visible: false,
         form: false,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'usuario_usuario',
         dbname: 'usuario',
         label: 'usuario',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'usuario_contrasena',
         dbname: 'contrasena',
         label: 'contrasena',
         visible: false,
         form: true,
         filter: false,
         type: 'password',
      },
      {
         id: 'usuario_fecha_creacion',
         dbname: 'fecha_creacion',
         label: 'fecha_creacion',
         visible: true,
         form: false,
         filter: false,
         type: 'datetime',
      },
      {
         id: 'usuario_fecha_eliminacion',
         dbname: 'fecha_eliminacion',
         label: 'fecha_eliminacion',
         visible: false,
         form: false,
         filter: false,
         type: 'datetime',
      },

   ];
};

export const UsuarioValidationSchema = (t) => {
   return yup.object().shape({
      id: yup.number().nullable(),
      usuario: yup.string().nullable(),
      contrasena: yup.string().nullable(),
      fecha_creacion: yup.date().nullable(),
      fecha_eliminacion: yup.date().nullable(),

   });
};

export const UsuarioFilterValidationSchema = (t) => {
   return yup.object().shape({
      id: yup.number().nullable(),
      usuario: yup.string().nullable(),
      contrasena: yup.string().nullable(),
      fecha_creacion: yup.date().nullable(),
      fecha_eliminacion: yup.date().nullable(),

   });
};